import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {validateEmpty} from '../../../global/custom-validate';
import {ToastrService} from 'ngx-toastr';
import {LoginService} from '../../../service/login/service-login';
import {language} from '../../../language/vn';
import {Router} from '@angular/router';
@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})
export class EgovLoginComponent implements  OnInit{
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public submitValidate = false;
  constructor(  public router: Router,
                public formBuilder: FormBuilder,
                public toastr: ToastrService,
                public loginService: LoginService
  ) {
  }
  ngOnInit(): void {

    this.frmGroup = new FormGroup({
      userName: new FormControl('0'),
      password: new FormControl()
    });
    this.frmGroup = this.formBuilder.group({
      userName: ['' , Validators.compose([validateEmpty]) ],
      password: ['' , Validators.compose([validateEmpty]) ]
    });
  }
  get f() { return this.frmGroup.controls; }
  public onSubmit()
  {
    this.submitValidate = true;
    if(this.frmGroup.invalid)
      return;
    this.loginService.getToken(this.frmGroup.value).subscribe(
      {    next: (data) => {
          if(data.userId!=0 && data.token!='ERRORLOGIN') {
            this.router.navigate(['']);
            this.toastr.success(language.message_success_login, language.message);
          }else
          {
            this.toastr.error(language.message_error_login, language.message);
          }
        },
        error: error => {
          this.toastr.error(language.message_error_login, language.message);
        }
      });
  }

}
